import { TipoIstanzaFascicoloVO } from "./tipo-istanza-fascicoloVO";
import { ClassificaVO } from "./classificaVO";
import { ProcedimentoVO } from "./procedimentoVO";
import { UtenteVO } from "./utenteVO";
import { IstanzeProcedimentoVO } from "./istanze-procedimentoVO";
import { TempiConservazioneVO } from "./tempi-conservazioneVO";
import { DatiPersonaliVO } from "./dati-personaliVO";
import { RiferimentoFascicoloCartaceoVO } from "./riferimento-fascicolo-cartaceoVO";
import { CampoSpecificoFascicoloVO } from "./campo-specifico-fascicoloVO";
import { RiferimentoEsternoVO } from "./riferimento-esternoVO";
import { StatoFascicoloEnum } from "../enum/stato-fascicolo-enum";
import { DatiReportorioManualiVO } from "./dati-repertorio-manualiVO";
import { UnitaDocumentariaVO } from "./unita-documentariaVO";
import { CommentoVO } from "./commentoVO";
import { VisibilitaFascicoloVO } from "./visibilita-fascicoloVO";
import { SettoreVO } from "./settoreVO";
import { RiferimentiPosizioneVO } from "./riferimenti-posizioneVO";
import { TipologiaFascicoloVO } from "./tipologia-fascicoloVO";
import { WrapperCollegamentoFascicoloVO } from "./wrapper-collegamento-fascicoloVO";
import { LinguaVO } from "./linguaVO";
import { MetadatiRepertorioVO } from "./metadati-repertorioVO";
import { IstanzaAttivitaVO } from "./istanza-attivitaVO";
export class FascicoloVO {
  id: string;
  tipologia: TipoIstanzaFascicoloVO;
  tipologiaFascicolo: TipologiaFascicoloVO;
  oggetto: string;
  descrizione: string;
  nome: string;
  classifica: ClassificaVO;
  classificaAggiuntiva: ClassificaVO;
  segnaturaArchivistica: string; //es. 	A.010.020/GEN/2019/0000001
  stato: StatoFascicoloEnum;
  ibrido: boolean; // settare a true quando è presente dentro roba cartacea.
  riferimentoPosizione: RiferimentiPosizioneVO = new RiferimentiPosizioneVO();
  dataApertura: string;
  dataChiusura: string;
  dataAnnullamento: string;
  dataManuale: string;
  dataUltimaModifica: string;
  estremoRemoto: string;
  estremoRecente: string;
  creatoDa: UtenteVO;
  strutturaResponsabile: SettoreVO;
  riferimentoFascicoloEsterno: RiferimentoEsternoVO;
  datiReportorio: DatiReportorioManualiVO;
  motivoEccezioneTempiConservazione: string;
  tempiConservazione: TempiConservazioneVO = new TempiConservazioneVO();
  attivitaAssociata: IstanzaAttivitaVO;
  datiPersonali: DatiPersonaliVO;
  sottoFascicoli: FascicoloVO[];
  documenti: UnitaDocumentariaVO[] = new Array<UnitaDocumentariaVO>(); // fare refactor
  commenti: CommentoVO[];
  place: string;
  riferimentoFascicoloCartaceo: RiferimentoFascicoloCartaceoVO;
  campiSpecifici: CampoSpecificoFascicoloVO[];
  //campoSpecificoConservazione: CampoSpecificoConservazioneVO;
  referenteFascicolo: UtenteVO;
  visibilitaFascicolo: VisibilitaFascicoloVO[];
  condizioniRiproduzione: string;
  condizioniConsultazione: string;
  fascicoliCollegati: WrapperCollegamentoFascicoloVO[];
  // dati hidden
  presenzaUdCartacee: boolean = false;
  presenzaDataManuale: boolean = false;

  dataManualeFascicoloPadre: string;
  lingue: LinguaVO[];
  dimensioni: number;
  altraDenominazione: string;
  dataVersione: string;
  contestoIstituzionale: string;
  documentazioneSeparata: boolean;
  repertoriato: boolean;
  metadatiRepertorio: MetadatiRepertorioVO;
  datiRepertorioManuali: DatiReportorioManualiVO;
  struttureAggiuntive: SettoreVO[];
  modificatoDaLinneo: boolean;
}
